import React, { Component } from 'react';
import coverPhoto from '../images/official-engagement-photo.jpg';
import Navbar from './components/Navbar';
import Divider from './components/Divider';

class Home extends Component {
    state = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        weddingDate: new Date(this.props.weddingDate).getTime(),
        timeoutId: ""
    }

    componentDidMount() {
        const timeoutId = this.runCountdown();
        this.setState({
            timeoutId: timeoutId
        })
    }

    componentWillUnmount() {
        clearTimeout(this.state.timeoutId);
    }

    runCountdown() {
        const now = new Date().getTime();
        const currentYear = new Date().getFullYear();
        const difference = now - this.state.weddingDate;
        if(difference > 0) {
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const days = Math.floor((difference % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24));
            const years = Math.floor((difference % (1000 * 60 * 60 * 24 * 365 * currentYear)) / (1000 * 60 * 60 * 24 * 365));
            setTimeout(() => this.runCountdown(), 1000);
            this.setState({
                years: years,
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds
            })
        }
    }

    render() {
        const { homeData } = this.props;
        const { years, days, hours, minutes } = this.state;
        const yearText = years > 1 ? years + " years" : years + " year";
        const dayText = days === 1 ? days + " day" : days + " days";
        const hourText = hours === 1 ? hours + " hr" : hours + " hrs";
        const minuteText = minutes === 1 ? minutes + " min" : hours + " mins";
        return (
            <div className="App">
                <Navbar showTitle={true}/>
                <img src={coverPhoto} className="img-center" alt="engagement in Kyoto"/>
                <p className="caption">Photo by <a href="https://www.reypaulweddings.com/" target="_blank" rel="noopener noreferrer">Rey Paul Weddings</a></p>
                <Divider/>
                <div className="App-details">
                    <p className="App-details-title">{homeData.date}</p>
                    <p className="App-details-header">{homeData.location}</p>
                    <p>Married: {years > 0 ? yearText : ""} {dayText} {hourText} {minuteText}</p>
                    <p>{homeData.text}</p>
                </div>
            </div>
        );
    }
}

export default Home;